import React, { useEffect, useState } from "react";
import Button from "../../components/Button";
import DesktopContainerAuth from "../../components/DesktopContainerAuth";
import Label from "../../components/Label";
import Loading from "../../components/Loading";
import handleErrors from "../../helpers/handleErrors";
import { schemaForgotPassword } from "./validation";
import { useHistory } from "react-router-dom";
import TextInput from "../../components/TextInput";
import ContactAuth from "../../components/Views/ContactAuth";
import TermOfUse from "../../components/Views/TermOfUse";
import { passwordRequest } from "../../services/auth";
import toastMessage from "helpers/handleToastMessage";
import { ToastContainer } from "react-toastify";

type Props = {};

const ForgotPassword: React.FC<Props> = (): JSX.Element => {
  let history = useHistory();

  const [role, setRole] = useState("");
  useEffect(() => {
    localStorage.clear();
    setRole(history.location.pathname.split("/")[2]);
    localStorage.setItem("role", role);
  }, [history, role]);

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>();

  const addClassButton = () => {
    if (errors?.email) {
      return "bg-bt-red text-bt-white";
    }

    if (email) {
      return "bg-bt-green text-bt-white";
    }

    return "bg-bt-light-gray text-bt-black";
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      if (!schemaForgotPassword.isValidSync({ email })) {
        handleErrors({
          schema: schemaForgotPassword,
          stateData: { email },
          setErrorMessage: setErrors,
        });
        setLoading(false);
        return;
      }

      const { data } = await passwordRequest({ email, role });

      toastMessage({
        message: "Verification code send successfully.",
        type: "success",
      });

      if (data) {
        history.push(`/activation-code/${role}`, {
          state: data.state,
          email,
          role,
        });
      }
    } catch (error: any) {
      let message;

      if (error.response.status === 404) {
        message = "User not found.";
        setErrors({ email: "User not found." });
      }

      if (error.response.status === 422) {
        message = "This email is not registered in our systems.";
        setErrors({ email: "This email is not registered in our systems." });
      }

      toastMessage({
        message: message ? message : "Error, Something went wrong.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <DesktopContainerAuth>
      <div className="flex flex-col">
        <Loading loading={loading} />
        <div className="w-96 mx-auto">
          <Label
            label={"Forgot Password?"}
            className="font-light text-xl text-bt-purple"
          />
          <Label
            label={
              "Please enter your email address to receive a verification code"
            }
            style={{
              color: "#4D4F5C",
              opacity: 0.5,
            }}
            className="mt-4 text-center font-light text-base"
          />
          <TextInput
            placeholder={"Email"}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            isHelp={errors?.email}
            helpText={errors?.email}
          />
          <Button
            label={"Reset password"}
            className={`mt-12 w-full h-8 rounded-lg font-sora font-normal2 text-base ${addClassButton()}`}
            onClick={handleSubmit}
          />
        </div>
        <ContactAuth
          title={"Request your access"}
          subTitle={
            "Are you an adoption professional and feel this would be the perfect solution for your business?"
          }
          titleButton={"Contact form"}
          action={"/signup/entity"}
        />
        <TermOfUse />
      </div>
      <ToastContainer />
    </DesktopContainerAuth>
  );
};

export default ForgotPassword;
